// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__38Lf7","error":"Textarea_error__3B9uN","readonly":"Textarea_readonly__3I7QQ","disabled":"Textarea_disabled__1Ai-S"};